// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87a6dd78","455":"a6c0a677"}[chunkId] + ".chunk.js";
};